import {
  Application,
  OutgoingApplication,
  Offer,
  Disclosure,
} from '@ads-bread/shared/bread/codecs';
import { APIFetch, APIResponse } from '../hooks/apiFetch';
import { HandlerResponse, handleResponse } from './base';

export const APPLICATION_URI = '/api/application';

interface ApplicationPrepareCheckoutOptions {
  application: Application;
  disclosures: Disclosure[];
  selectedOffer: Offer;
  iovationBlackboxId?: string | null;
  paymentMethodID?: string | null;
  decibelSessionId?: string;
}
export async function applicationPrepareCheckout(
  {
    application,
    disclosures,
    selectedOffer,
    iovationBlackboxId,
    paymentMethodID,
    decibelSessionId,
  }: ApplicationPrepareCheckoutOptions,
  apiFetch: APIFetch
): Promise<HandlerResponse<Application>> {
  const dedupedDisclosures = [
    ...new Map(
      [...(application?.disclosures || []), ...disclosures].map(
        (disclosure) => [disclosure.type, disclosure]
      )
    ).values(),
  ];

  const body = {
    ...application,
    disclosures: dedupedDisclosures,
    paymentAgreementID: selectedOffer.paymentAgreement.id,
    ...(paymentMethodID ? { paymentMethodID } : {}),
  };

  const clientInfo = [];

  if (iovationBlackboxId) {
    clientInfo.push({
      type: 'iovationBlackbox',
      value: iovationBlackboxId,
    });
  }

  if (decibelSessionId) {
    clientInfo.push({
      type: 'decibel_session_id',
      value: decibelSessionId,
    });
  }

  body.clientInfo = clientInfo;

  const res: APIResponse<Application> = await apiFetch<
    Application,
    OutgoingApplication
  >(
    `${APPLICATION_URI}/${application?.id}/prepare-checkout`,
    { body },
    Application
  );
  return handleResponse(res);
}
